import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from "lodash";

@Component({
    selector: 'app-module-section',
    templateUrl: './module-section.component.html',
    styleUrls: ['./module-section.component.scss']
})
export class ModuleSectionComponent implements OnInit {
    @Input() sectionName: string;
    @Input() sectionData: Array<any>;
    @Input() readonly: boolean;
    @Output() onSectionDataChange = new EventEmitter<any>();

    constructor() {
    }

    /**
     * Hide unused module when form is in readonly mode
     */
    ngOnInit() {
        this.sectionData = this.readonly ? this.hideUnusedSection(this.sectionData) : this.sectionData;
    }

    hideUnusedSection(data) {
        return _.filter(data, (section) => {
            if (section.hasOwnProperty('childrens'))
                section.childrens = this.hideUnusedSection(section.childrens);
            return section['base_config'].unit_quantity;
        });
    }

    updateSection(event) {
        event['section_name'] = this.sectionName;
        this.onSectionDataChange.emit(event);
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/shared/module-section/module-section.component.ts